module.exports = __webpack_public_path__ + "static/media/D285EF48-BD7C-4843-943C-EDA7C9F6388F-removebg-preview.d63db9e9.png";